/* eslint no-param-reassign: 0 */

const initialState = {};

const gettersDef = {};

const URL_PREFIX = "/brapp/sales";

const actions = {
  fetchProducts({ dispatch, rootGetters }, { params = {} } = {}) {
    const mergedParams = {
      ...params,
      company: rootGetters["auth/activeCompany"].id
    };
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `${URL_PREFIX}/products/`, params: mergedParams },
      { root: true }
    );
  },
  createProduct({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "post", url: `${URL_PREFIX}/products/`, data },
      { root: true }
    );
  },
  updateProduct({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "put", url: `${URL_PREFIX}/products/${data.id}/`, data },
      { root: true }
    );
  },
  patchProduct({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "patch", url: `${URL_PREFIX}/products/${data.id}/`, data },
      { root: true }
    );
  },
  deleteProduct({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "delete", url: `${URL_PREFIX}/products/${id}/` },
      { root: true }
    );
  },
  fetchProduct({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `${URL_PREFIX}/products/${id}/` },
      { root: true }
    );
  },

  fetchLocations({ dispatch, rootGetters }, { params = {} } = {}) {
    const mergedParams = {
      ...params,
      company: rootGetters["auth/activeCompany"].id
    };
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `${URL_PREFIX}/locations/`, params: mergedParams },
      { root: true }
    );
  },
  createLocation({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "post", url: `${URL_PREFIX}/locations/`, data },
      { root: true }
    );
  },
  updateLocation({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "put", url: `${URL_PREFIX}/locations/${data.id}/`, data },
      { root: true }
    );
  },
  patchLocation({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "patch", url: `${URL_PREFIX}/locations/${data.id}/`, data },
      { root: true }
    );
  },
  deleteLocation({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "delete", url: `${URL_PREFIX}/locations/${id}/` },
      { root: true }
    );
  },
  fetchLocation({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `${URL_PREFIX}/locations/${id}/` },
      { root: true }
    );
  },

  fetchCategories({ dispatch, rootGetters }, { params = {} } = {}) {
    const mergedParams = {
      ...params,
      company: rootGetters["auth/activeCompany"].id
    };
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `${URL_PREFIX}/categories/`, params: mergedParams },
      { root: true }
    );
  },
  createCategory({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "post", url: `${URL_PREFIX}/categories/`, data },
      { root: true }
    );
  },
  updateCategory({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "put", url: `${URL_PREFIX}/categories/${data.id}/`, data },
      { root: true }
    );
  },
  patchCategory({ dispatch }, { data }) {
    return dispatch(
      "api/sendRequest",
      { method: "patch", url: `${URL_PREFIX}/categories/${data.id}/`, data },
      { root: true }
    );
  },
  deleteCategory({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "delete", url: `${URL_PREFIX}/categories/${id}/` },
      { root: true }
    );
  },
  fetchCategory({ dispatch }, { id }) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: `${URL_PREFIX}/categories/${id}/` },
      { root: true }
    );
  }
};

const mutations = {};

export default {
  namespaced: true,
  state: initialState,
  getters: gettersDef,
  actions,
  mutations
};
